import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { Box, Typography, Icon, RaiseColors, makeStyles, useTheme } from "client/componentLibrary";
import useWindowSize from "hooks/useWindowSize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    container: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      minHeight: "60vh"
    },
    textContainer: {
      marginTop: 8
    }
  };
});
var EmptyView = function EmptyView(_ref) {
  var _windowSize$innerWidt;
  var icon = _ref.icon,
    headerText = _ref.headerText,
    subheaderText = _ref.subheaderText;
  var classes = useStyles();
  var windowSize = useWindowSize();
  var theme = useTheme();
  var inMobileView = ((_windowSize$innerWidt = windowSize.innerWidth) !== null && _windowSize$innerWidt !== void 0 ? _windowSize$innerWidt : 0) <= _valuesInstanceProperty(theme.breakpoints).md;
  return /*#__PURE__*/_jsxs(Box, {
    className: classes.container,
    children: [/*#__PURE__*/_jsx(Icon, {
      className: icon,
      fontSize: inMobileView ? 72 : 160,
      color: RaiseColors.gray200,
      "data-testid": "emptyViewIcon"
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.textContainer,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: inMobileView ? "h4" : "h3",
        weight: "semibold",
        color: RaiseColors.destructive500,
        children: headerText
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginTop: 8
        },
        children: /*#__PURE__*/_jsx(Typography, {
          color: RaiseColors.black,
          children: subheaderText
        })
      })]
    })]
  });
};
export default EmptyView;